<template>
    <div class="page-content g9">
        <Accord title="Distribution">

            <Accord title="Site and depot locations">
                <DistributionMap chart-name="distributionMap"></DistributionMap>

            </Accord>
            <Accord title="Supply plans">
                <p>
                    Supply plans determines dun requests and available stock depots and sites. Download all supply plands that has been used/generated.
                </p>
                <button class="right" v-on:click="onDownloadSupplyPlansClick">Download supply plans in excel</button>
            </Accord>
            <Accord title="Shipments">
                <LineChart chart-name="distributionShipments" :settings="shipmentSettings" v-bind:buttonLoad="true"></LineChart>
                <button class="right" v-on:click="onDownloadShipmentsClick">Download all shipments in excel</button>
            </Accord>

            <Accord title="DUN Request">
                <LineChart chart-name="distributionDunRequest" :settings="dunRequestSettings" v-bind:buttonLoad="true"></LineChart>
                <button class="right" v-on:click="onDownloadDunRequestsClick">Download all dun requests in excel</button>
            </Accord>

            </Accord>
</div>
</template>

<script>
    import Accord from "../../Accord.vue"
    import LineChart from "../Charts/LineChart.vue"
    import DistributionMap from "../Charts/DistributionMap.vue"

    export default {
        components: {
            Accord,
            LineChart,
            DistributionMap
        },
        methods: {
            dunRequestSettings(data) {
                let chart = this.cloneObject(this.$store.state.dataView.chartDefaults);
                chart.chart = {
                    type: "column",
                    zoomType: "x"
                };

                for(let serie of data.series){
                    serie.turboThreshold = 0;
                }

                chart.series = data.series;
                chart.xAxis.type = "datetime";
                chart.yAxis.title.text = "DUN";
                chart.xAxis.title.text = "Date";
                chart.plotOptions.column.stacking = "normal";

                chart.tooltip = {
                    useHTML: true,
                    headerFormat: '<span style="color: {series.color}">{series.name} </span><table>',
                    pointFormat: '' +
                        '<tr><td>Order Date</td><td style="text-align: right"><b>{point.date}</b> </td></tr>' +
                        '<tr><td>Arrival Date</td><td style="text-align: right"><b>{point.arrivalDate}</b> </td></tr>' +
                        '<tr><td>Order Quantity</td><td style="text-align: right"><b>{point.y}</b> </td></tr>' +
						'<tr><td>Order Dispatched</td><td style="text-align: right"><b>{point.dispatched} </b></td></tr>' +
                        '<tr><td>Supplier</td><td style="text-align: right"><b>{point.supplier}</b> </td></tr>' +
                        '<tr><td>Reciever(s)</td><td style="text-align: right"><b>{point.receivers}</b> </td></tr>',
                    footerFormat: '</table>',
                    valueDecimals: 2
                };

                return chart;
            },
            onDownloadShipmentsClick() {
                window.open("/api/download/Shipments?id=" + this.$route.params.id)
            },
            onDownloadSupplyPlansClick() {
                window.open("/api/download/SupplyPlans?id=" + this.$route.params.id)
            },
            onDownloadDunRequestsClick() {
                window.open("/api/download/DunRequests?id=" + this.$route.params.id)
            },
            shipmentSettings(data) {
                let chart = this.cloneObject(this.$store.state.dataView.chartDefaults);
                chart.chart = {
                    type: "column",
                    zoomType: "x"
                };
                chart.series = data.series;
                chart.xAxis.type = "datetime";
                chart.yAxis.title.text = "DUN";
                chart.xAxis.title.text = "Date";
                chart.plotOptions = {
                    column: {
                        stacking: "normal"
                    },
                    series: {
                        pointWidth: 6
                    }
                };
                chart.legend.enabled = false;

                chart.tooltip = {
                    useHTML: true,
                    formatter: function (tooltip) {
                        let html = `<span style="color: ${this.series.color}">Shipping ID ${this.series.name} </span><table>`;
                        html += `<tr><td>Order Date</td><td style="text-align: right"><b>${this.point.date}</b></td></tr>`;
                        
                        if (typeof this.point.arrivalDate != 'undefined') {
                            html += `<tr><td>Arrival Date</td><td style="text-align: right"><b>${this.point.arrivalDate}</b></td></tr>`;
                        }
                        html += `<tr><td>Destination</td><td style="text-align: right"><b>${this.point.destination}</b></td></tr >`;
                        html += `<tr><td>Shipper Type Capacity</td><td style="text-align: right"><b>${this.point.shipperCapacity}</b></td></tr>`;
                        html += `<tr><td>Shipper Type</td><td style="text-align: right"><b>${this.point.shipperType}</b></td></tr>`;
                            

                        
                        html += `<tr><td><i>Duns</i></td><td></td></tr>`;
                        for (let item of this.point.dun) {
                            html += `<tr><td><i>${item.name}</i></td><td style="text-align: right"><b>${item.quantity}</b></td></tr>`;
                        }
                        

                        html += `<tr><td>Units in shipment</td><td style="text-align: right"><b>${this.point.totalUnits}</b></td></tr>`;
                                                
						

                        html += "</table>";

                        return html;
                    }
                };

                return chart;
            }
        }
    }
</script>
